"use client";

import { useCallback } from "react";
import { useExpandingMenu } from "./expanding-menu.context";
import {
  expandingMenuTriggerStyles,
  expandingMenuTriggerIconStyles,
  expandingMenuTriggerTextStyles,
} from "./styles/expanding-menu-trigger.styles";

import type { ExpandingMenuTriggerProps } from "./types/expanding-menu-trigger.types";
import { IconChevronDown } from "../../icons";

export const ExpandingMenuTrigger: React.FC<ExpandingMenuTriggerProps> = (props) => {
  const { children, onClick, className, ...rest } = props;

  const { toggleExpanded, expanded } = useExpandingMenu();

  const styles = expandingMenuTriggerStyles({ className });

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      toggleExpanded();
      onClick?.(e);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- onClick is a callback prop that may change identity frequently
    [toggleExpanded],
  );

  return (
    <button onClick={handleClick} className={styles} {...rest}>
      <span className={expandingMenuTriggerTextStyles()}>{children}</span>
      <span className={expandingMenuTriggerIconStyles({ expanded })}>
        <IconChevronDown size="m" />
      </span>
    </button>
  );
};

ExpandingMenuTrigger.displayName = "ExpandingMenuTrigger";
